function acceptRequestDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/accept-request/accept-request-dialog.html?$$REVISION$$'
  }
}

export { acceptRequestDialogDirective }
